import { render, staticRenderFns } from "./TermsnCondition.vue?vue&type=template&id=c66ab026"
import script from "./TermsnCondition.vue?vue&type=script&lang=js"
export * from "./TermsnCondition.vue?vue&type=script&lang=js"
import style0 from "./TermsnCondition.vue?vue&type=style&index=0&id=c66ab026&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports